import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { StepActionTypeSchema } from '../../shared/step-action-type.schema';
/**
 * Merge Candidate Schema
 * A completed step recording eligible for merging
 */ export const MergeCandidateSchema = z.object({
    _id: z.string(),
    generatedName: z.string().optional(),
    generatedDescription: z.string().optional(),
    actionType: StepActionTypeSchema.optional(),
    output: z.string().optional()
});
/**
 * Merge Candidates Request Schema
 * GET /api/v2/process-step-recording/merge-candidates?assignmentId=:assignmentId
 */ export const MergeCandidatesRequestSchema = z.object({
    assignmentId: z.string().regex(/^[a-f\d]{24}$/i)
});
/**
 * Merge Candidates Response Schema
 */ export const MergeCandidatesResponseSchema = z.object({
    candidates: z.array(MergeCandidateSchema)
});
/**
 * Merge Candidates Error Schema
 */ export const MergeCandidatesErrorSchema = BaseErrorSchema;

//# sourceMappingURL=merge-candidates.schema.js.map